var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _circle, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    className: "iconify iconify--emojione",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 7c-16.1 4.3-20.2 18.5-20.2 18.5L41 28.9C39.6 22.3 44.8 7 44.8 7",
    fill: "#b2c1c0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.5 21.3 13.1-1.8s.2-1.1.4-1.9c-8.8.1-13.5 3.7-13.5 3.7",
    fill: "#879191"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1 9.4s3 3 3.8 5.9c4.7 3.2 5.1 7.9 5.1 11 0 10.9-17.2 21.4-17.2 21.4L2 38.5c0-4.3 19.2-19 39-19 6.9 0 16 4.9 18.1 2.6 1.2-1.3-1.3-5.3-2.5-5.3 0 0 .1 2.6-1.2 4.2.5-5.9-2.3-11.6-2.3-11.6",
    fill: "#b2c1c0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 55.2s0-17 16.6-23.8c0 0 9.5 19.2-16.6 23.8",
    fill: "#ff717f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 38.3S22 48.4 21.9 52.8c0 0 16.5-5.1 12.5-20.6z",
    fill: "#ed4c5c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6 35.5s-3.5 6-4.1 11.5 8.5-2.8 9.3-13.6z",
    opacity: 0.5,
    fill: "#3e4347"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m15.9 48.2 3.3 2.1-.6-3.9 3 2.2-.6-4 3.5 2.6-1.2-4.9 3.8 3.2-1-5.3 3.9 3.2-1.3-5.2 3.7 2.6-1.2-4.8 3.4 3.3-1.1-5.4s-8.4 5.3-17.6 14.3",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m19.2 50.3-3.3-2.1 1.2-1.1zm-.7-3.9 3 2.2-2-3.8zm2.4-1.8 3.5 2.6-2.5-4.5zm2.4-2.3 3.8 3.2-2.5-4.6zm2.7-2.1 3.9 3.2-2.8-5zm2.6-2 3.7 2.6-2.7-4.2zm2.6-2.2 3.4 3.3-2.3-4.6z",
    fill: "#b2c1c0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.4 40.9-2.2-1 1.3 3.8c.5-1.1.8-2.1.9-2.8m-1.1 3.2-3.2-1.3 1.4 4c.8-1 1.3-1.9 1.8-2.7m-2.2 3.1-3.2-1.8.9 3.9c.8-.7 1.6-1.4 2.3-2.1m-2.7 2.4-3.3-2.3.8 3.9c1-.5 1.8-1 2.5-1.6m-2.8 1.9-3.4-2.6s.5 3.2.6 4c1.1-.4 2-.9 2.8-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 52.9-3.5-2.8c.2 1.6.7 4 .7 4 1-.4 1.9-.8 2.8-1.2"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m35 42.4-1.9-2.6 1.3 3.8c.3-.3.5-.8.6-1.2m-1.7 3.2-2.2-2.9 1.4 4c.3-.3.6-.7.8-1.1m-2.5 2.9-2-3.1.9 3.9c.4-.2.8-.5 1.1-.8m-2.7 2-2-3.2.8 3.9c.5-.2.9-.4 1.2-.7m-3 1.9L23.3 49l.6 4.1c.4-.3.8-.5 1.2-.7m-2.8 1.3-1.7-3.6.7 4c.3-.1.6-.3 1-.4m-6.6-5.1s23.6-15.7 21.8-18.3L24 35.7z",
    fill: "#b2c1c0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.7,
    cy: 29.6,
    r: 3.3,
    fill: "#3e4347"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 32.1s4 .8 6-2.5 4.8-3.5 8.6-3.7c0 0-6.1-1.5-9.1.8s-2.8 4.7-5.5 5.4",
    fill: "#76807f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44 28.6s1.4-.9 1.6-1.9c.3-1.1 1.2-3.2-.1-4.4 0 0 1.8 1 1.1 3.6-.6 2.5-1.5 2.5-2.6 2.7m1.7.8s1.4-.7 1.8-1.8c.4-1 1.4-3.1.3-4.4 0 0 1.7 1.1.8 3.6-.9 2.6-1.8 2.5-2.9 2.6m2.2.8s1.4-.8 1.7-1.8 1.4-3.1.1-4.4c0 0 1.7 1.1.9 3.6-.7 2.5-1.6 2.5-2.7 2.6",
    opacity: 0.5,
    fill: "#3e4347"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 38.3s3.9-.8 4.8 0l-1.5 1.5z",
    fill: "#879191"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 38.3C59.8 38.3 62 57 62 57s-8.1-11-18.4-11z",
    fill: "#b2c1c0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2 38.5c0-1.1 11.9-3 20.3-.2s10.6-12.4 14.8-11.2c4.6 1.3 1 15.6 10.4 19.4-8.7 7.8-21.6 12.6-27.7 8.7 23.9-7.9 16.9-22.4 16.9-22.4S26.6 45 15.9 48.7C12 50.1 2 42 2 38.5",
    fill: "#e8e8e8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 39.5s1.6-1 3 0c.6.4-.1 1.3-1.3 1.3-1.1-.1-.7-1-1.7-1.3",
    fill: "#3e4347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShark);
export default __webpack_public_path__ + "static/media/shark.c998aa50a90ab926a6672efc9e5448c8.svg";
export { ForwardRef as ReactComponent };